class ScaleAnswers extends React.Component {
  scale(start, finish){
    let table = [];
    let max = finish;
    for (let i = start; i <= max; i++){
      let children = [];
      let classLabel = "custom-control-label label-value color"
      let nameId = this.props.questionName + '_' + i;
      children.push(<input type="radio" className="custom-control-input" id={nameId} name={this.props.questionValue} value={i} onChange={this.props.handleChange(this.props.questionLabel, this.props.number, this.props.questionType)} required />)
      children.push(<label className={classLabel} htmlFor={nameId}>{i}</label>)
      
      table.push(<div className="custom-control custom-radio custom-control-inline label-radio">{children}</div>);
    }
    return (
      table
    );
  }

  render() {
    return (<div className="conteiner">
          <div className=""><img class="img-smile" src="/survey/images/smile_bad.png"/></div>
      <div className="row justify-content-center col-12 sc ">
          <div className="d-inline-flex align-items-center scale">
            {this.scale(0,5)}
          </div>
          <div className="d-inline-flex align-items-center scale">
            {this.scale(6,10)}
          </div>
      </div>
          <div className="smile_right"><img class="img-smile" src="/survey/images/smile_good.png"/></div>
    </div>)
  }

};

export default ScaleAnswers;



// WEBPACK FOOTER //
// in/js/components/scale-answers.js